<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>{{ 'PERSONAL_PROFILE' | translate }}</mat-card-title>
  </mat-card-header>
  <ng-container *ngIf="userProfileFormGroup$ | async as userForm; else loadingUserProfile">
    <mat-card-content>
      <!-- NAME / EMAIL SECTION -->
      <glxy-input
        class="form-input"
        [formControl]="userForm.controls.first_name"
        [required]="true"
        [label]="'FIRST_NAME'"
      ></glxy-input>
      <glxy-input
        class="form-input"
        [formControl]="userForm.controls.last_name"
        [required]="true"
        [label]="'LAST_NAME'"
      ></glxy-input>
      <glxy-input class="form-input" [formControl]="userForm.controls.email" [label]="'EMAIL'"></glxy-input>
      <!-- END NAME / EMAIL SECTION -->

      <!-- PHOTO SECTION -->
      <div class="photo-section-title">
        <strong>{{ 'PHOTO.TITLE' | translate }}</strong>
      </div>
      <div class="upload-photo-container row">
        <img src="{{ userForm.controls.profile_image.value }}" alt="profile-image" />
        <div class="upload-photo-actions">
          <button mat-stroked-button (click)="uploadPhotoModal(userForm)">
            <ng-container>
              {{ 'PHOTO.ACTIONS.UPLOAD_NEW' | translate }}
            </ng-container>
          </button>
          <div class="remove-photo-link">
            <a mat-button (click)="removeImage(userForm, disabledRemoveImg)" [disabled]="disabledRemoveImg">
              {{ 'PHOTO.ACTIONS.REMOVE' | translate }}
            </a>
          </div>
        </div>
      </div>
      <!-- END PHOTO SECTION -->

      <!-- PHONE SECTION -->
      <div class="phone-section-wrapper">
        <div class="photo-section-title">
          <strong>{{ 'PHONES.TITLE' | translate }}</strong>
        </div>

        <div class="row" *ngFor="let control of userForm.controls.phone_numbers.controls; index as i">
          <div class="col col-md-6">
            <glxy-phone-input class="form-input" [formControl]="control.get('phone')"></glxy-phone-input>
          </div>
          <div class="ext-wrapper col col-md-2">
            <glxy-input class="form-input" [formControl]="control.get('ext')" type="number" label="Ext"></glxy-input>
          </div>
          <div class="col col-md-2 delete-phone-button-wrapper">
            <button mat-button matTooltip="Remove" (click)="deletePhoneNumber(userForm, i)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

        <div *ngIf="canAddMorePhones" class="add-phone-link">
          <a mat-button (click)="addPhoneNumber(userForm)">
            {{ 'PHONES.ADD' | translate }}
          </a>
        </div>
      </div>
      <!-- END PHONE SECTION -->

      <!-- ADDRESS SECTION -->
      <div class="address-section-title">
        <strong>{{ 'ADDRESS.TITLE' | translate }}</strong>
      </div>
      <glxy-select-input
        class="form-input"
        *ngIf="countryOptions$ && (countryOptions$ | async)?.length > 0"
        [formControl]="userForm.controls['country']"
        [label]="'COMMON.ADDRESS.COUNTRY'"
        [options]="countryOptions$ | async"
        [required]="true"
      ></glxy-select-input>
      <glxy-input
        class="form-input"
        [formControl]="userForm.controls['address']"
        [label]="'COMMON.ADDRESS.LINE_1'"
      ></glxy-input>
      <glxy-input
        class="form-input"
        [formControl]="userForm.controls['additionalAddressLine']"
        [label]="'COMMON.ADDRESS.LINE_2'"
      ></glxy-input>
      <glxy-select-input
        class="form-input"
        *ngIf="(stateProvOptions$$ | async)?.length > 0"
        [formControl]="userForm.controls['stateProv']"
        [label]="'COMMON.ADDRESS.STATE_PROV'"
        [options]="stateProvOptions$$ | async"
      ></glxy-select-input>
      <glxy-input
        class="form-input"
        [formControl]="userForm.controls['city']"
        [label]="'COMMON.ADDRESS.CITY'"
      ></glxy-input>
      <glxy-input
        class="form-input"
        [formControl]="userForm.controls['postalCode']"
        [label]="'COMMON.ADDRESS.POSTAL_CODE'"
      ></glxy-input>
      <!-- END ADDRESS SECTION -->
    </mat-card-content>

    <mat-card-actions>
      <button mat-flat-button color="primary" (click)="saveUserProfile(userForm)" [disabled]="isUserEditing">
        <ng-container *ngIf="!isUserEditing; else loadingSpinner">
          {{ 'ACTIONS.SAVE' | translate }}
        </ng-container>
        <ng-template #loadingSpinner>
          <div class="loading-spinner">
            <mat-spinner diameter="36"></mat-spinner>
          </div>
        </ng-template>
      </button>
    </mat-card-actions>
  </ng-container>
  <ng-template #loadingUserProfile>
    <div class="loading-spinner">
      <mat-spinner diameter="56"></mat-spinner>
    </div>
  </ng-template>
</mat-card>

<mat-card appearance="outlined" class="password-card">
  <mat-card-header>
    <mat-card-title>{{ 'PASSWORD.TITLE' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="updatePasswordFormGroup">
      <glxy-password-input
        class="form-input"
        id="current-password"
        [formControl]="updatePasswordFormGroup.controls.current_password"
        [required]="true"
        [label]="'PASSWORD.CURRENT_PASSWORD'"
      ></glxy-password-input>
      <glxy-password-input
        class="form-input"
        id="new-password"
        [formControl]="updatePasswordFormGroup.controls.new_password"
        [required]="true"
        [label]="'PASSWORD.NEW_PASSWORD'"
        [showPasswordStrength]="true"
        [confirmPassword]="true"
      ></glxy-password-input>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <button mat-flat-button color="primary" (click)="updatePassword()" [disabled]="isUpdatingPassword">
      <ng-container *ngIf="!isUpdatingPassword; else loadingSpinner">
        {{ 'ACTIONS.SAVE' | translate }}
      </ng-container>
      <ng-template #loadingSpinner>
        <div class="loading-spinner">
          <mat-spinner diameter="36"></mat-spinner>
        </div>
      </ng-template>
    </button>
  </mat-card-actions>
</mat-card>
